import { render, staticRenderFns } from "./ReviewAndBuy.vue?vue&type=template&id=3f336a48&scoped=true"
import script from "./ReviewAndBuy.vue?vue&type=script&lang=ts"
export * from "./ReviewAndBuy.vue?vue&type=script&lang=ts"
import style0 from "./ReviewAndBuy.vue?vue&type=style&index=0&id=3f336a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f336a48",
  null
  
)

export default component.exports